import React from "react";
import ProjectCard from "./ProjectCards";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { projects } from "../../data";

function Projects() {
  const headerRef     = useScrollReveal();
  const featuredRef   = useScrollReveal();
  const otherRef      = useScrollReveal();

  const featured = projects.filter((p) => p.featured);
  const others   = projects.filter((p) => !p.featured);

  return (
    <section id="projects" className="section projects-section">
      <div className="section-inner">
        <div ref={headerRef} className="reveal" style={{ marginBottom: "48px" }}>
          <p className="section-label">Work</p>
          <h2 className="section-title">
            Featured <span>Projects</span>
          </h2>
          <p className="section-subtitle">
            A selection of real-world platforms I've built and shipped — covering AI analytics, enterprise integration, meal delivery, and more.
          </p>
        </div>

        <div ref={featuredRef} className="projects-featured-grid reveal">
          {featured.map((project, i) => (
            <div key={project.id} style={{ transitionDelay: `${i * 0.08}s` }}>
              <ProjectCard project={project} />
            </div>
          ))}
        </div>

        {others.length > 0 && (
          <div ref={otherRef} className="reveal">
            <p className="other-grid-label">Other Projects</p>
            <div className="projects-other-grid">
              {others.map((project, i) => (
                <div key={project.id} style={{ transitionDelay: `${i * 0.07}s` }}>
                  <ProjectCard project={project} compact />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Projects;
